export default {
  dashboard: {
    abTest: {
      header: {
        feature: "A/B Test Results",
        title:
          "A/B test is currently running. Your Sales rep will schedule a check-in once the results are ready.",
      },
    },
    error: "Oops, something went wrong loading your dashboard. Please try again later.",
    titles: {
      main: "Dataships Dashboard",
      repeatPurchase: "Repeat Purchase Metrics",
      mcrSummary: "Marketing Consent Rate (MCR) Summary Table",
      monthlySummary: "Monthly Summary Table",
    },
    timePeriod: {
      label: "Time Period",
      allTime: "All time",
      thisMonth: "This Month",
      previousMonth: "Previous Month",
      previousThreeMonths: "Previous 3 Months",
      previousSixMonths: "Previous 6 Months",
      previousTwelveMonths: "Previous 12 Months",
    },
    tiles: {
      mcr: {
        title: "Marketing Consent Rate",
        tooltip:
          "The percentage of purchasers at checkout that were subscribed to marketing using Dataships app",
      },
      verifiedContacts: {
        title: "Verified Contacts",
        tooltip:
          "The contacts that have passed through the Dataships app at checkout and have a marketing compliance audit log associated with them",
      },
      subscribedContacts: {
        title: "Subscribed Contacts",
        tooltip:
          "Contacts that became subscribers or remained subscribers by passing through the Dataships app",
      },
      incrementalSubscribers: {
        title: "Incremental Subscribers",
        tooltip:
          "The subset of subscribed contacts who are new incremental subscribers",
      },
      repeatPurchasers: {
        title: "Repeat Purchasers",
        tooltip:
          "Repeat purchase orders placed by incremental subscribers since using Dataships (excluding first purchases)",
      },
      repeatPurchaseRevenue: {
        title: "Repeat Purchase Revenue",
        tooltip:
          "Total revenue generated from repeat purchases by incremental subscribers unlocked using the Dataships app",
      },
    },
    mcrSummaryTable: {
      withoutDataships: "Results without Dataships",
      withDataships: "Results with Dataships",
      verifiedContacts: "Verified Contacts",
      subscribedContacts: "Subscribed Contacts",
      nonSubscribedContacts: "Non-subscribed Contacts",
      mcr: "MCR",
      keyInsight:
        "Dataships has improved your Marketing Consent Rate from <1>{{preDatashipsMarketingConsentRate}}%</1> to <3>{{marketingConsentRate}}%</3>, representing a <5>{{mcrUplift}} percentage point increase.</5>",
    },
    charts: {
      mcr: {
        tooltip: "MCR",
        title: "MCR Movements",
        description: "Marketing Consent Rate (MCR) trends over time",
      },
      contactSummary: {
        tooltips: {
          verifiedContacts: "Verified Contacts",
          marketableContacts: "Marketable Contacts",
        },
        title: "Contact Summary",
        description: "Verified contacts and subscriber growth over time",
      },
      incrementalSubscribers: {
        tooltip: "Incremental Subscribers",
        title: "Incremental Subscribers",
        description: "Growth in new incremental subscribers over time",
      },
      repeatPurchases: {
        tooltip: "Revenue",
        title: "Repeat Purchases",
        description: "Revenue generated from repeat customers over time",
      },
    },
    monthlySummaryTable: {
      columns: {
        month: "Month",
        verifiedContacts: "Verified Contacts",
        mcr: "MCR",
        subscribedContacts: "Subscribed Contacts",
        incrementalSubscribers: "Incremental Subscribers",
        repeatPurchases: "Repeat Purchases",
        repeatPurchaseRevenue: "Repeat Purchase Revenue",
        total: "Total",
      },
    },
  },
  usage: {
    header: {
      feature: "Usage Dashboard",
      html: "Here's how your <1>Data</1> Relation<3>ships</3> are being kept up to date",
    },
    error: "Unable to fetch your Usage Dashboard, please try again later.",
    tabs: {
      overview: "Overview",
      last7Days: "Last 7 Days",
      last30Days: "Last 30 Days",
      last90Days: "Last 90 Days",
    },
    statsAndVideo: {
      verifiedContacts: "Verified Contacts",
      updates: "Updates to existing verified contacts",
      updatesMade: "Resulting updates made by Dataships",
    },
    howItWorks: {
      title: "How it works?",
      step1: {
        title: "Step 1",
        info: "When a verified contact is created or updated their Data RelationShip changes. See Data Relationships Created and Updated below.",
      },
      step2: {
        title: "Step 2",
        info: "We review the change, taking the above factors into account to determine the resulting marketable status of the contact.",
      },
      step3: {
        title: "Step 3",
        info: "We then create a new audit log to keep a record of the changes, and ensure that the marketable status is reflected across Klaviyo and Shopify. See Outputs & Syncs below.",
      },
    },
    dataRelationships: {
      titleLeft: "Data Relationships Created and Updated",
      titleRight: "Breakdown",
      stats: {
        verifiedContacts: "Verified Contacts",
        firstTimePurchases: "First time purchases",
        updates: "Updates to existing verified contacts",
        repeatPurchases: "Repeat Purchases",
        unsubscribes: "Unsubscibes",
        doubleOptIns: "Double opt-ins confirmed",
      },
    },
    outputAndSyncs: {
      titleLeft: "Ouput and Syncs",
      titleRight: "Breakdown",
      stats: {
        resultingUpdates: "Resulting updates made by Dataships",
        klaviyoListMovements: "Klaviyo List movements",
        klaviyoPropertyUpdates:
          "Updates to Dataships custom property in Klaviyo",
        shopifyUpdates: "Updates to Subscription status",
        auditLogs: "Audit logs created",
      },
    },
  },
} as const;
